import * as React from 'react';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import moment from 'moment';

export const BasicDateCalendar = ({ handleChangeDate, value, futureDisable = false, maxDate, zindexOverride }: any) => {
  const jsDate = moment(value, 'DD-MM-YYYY').toDate();
  return (
    <DateCalendar
      sx={{
        boxShadow: '0px 3px 14px 0px rgba(0, 0, 0, 0.08)',
        position: 'absolute',
        background: '#fff',
        zIndex: zindexOverride ? zindexOverride : 10,
        marginTop: '43px',
        width: '280px',
      }}
      defaultValue={jsDate}
      onChange={handleChangeDate}
      disableFuture={futureDisable}
      // THIN-7916: allow callers to hard-cap the selectable range (e.g. facility-local today) so a
      // future date of service cannot be picked. `disableFuture` alone keys off the browser day.
      maxDate={!!maxDate ? maxDate : null}
    />
  );
};


export const BasicDateRangeCalendar = ({
  handleChangeDate,
  value,
  futureDisable = false,
  minDate,
  maxDate,
  source = 'download',
}: any) => {
  const jsDate = moment(value, 'DD-MM-YYYY').toDate();
  return (
    <DateCalendar
      sx={{
        boxShadow: '0px 3px 14px 0px rgba(0, 0, 0, 0.08)',
        position: source === 'DueDate' ? 'none' : 'absolute',
        background: '#fff',
        zIndex: 10,
        height: '330px',
        width: '290px',
        margin: '0px',
        marginTop: source === 'DueDate' ? '0px' : '87px',
      }}
      defaultValue={jsDate}
      onChange={handleChangeDate}
      disableFuture={futureDisable}
      minDate={!!minDate ? minDate : null}
      maxDate={!!maxDate ? maxDate : null}
      fixedWeekNumber={6}
    />
  );
};
